import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styles from './CompanyInfo.module.css';
import { RootState } from '../../../../../../redux/rootState';
import { stripCustPrefix } from '../../../../../../utils/CommonFunctions';

function CompanyInfo() {
  const {
    customerAlert, smc, companyOtherCity, bidAlert, bidAlertNote, markup,
    companyName, customerName, address, companyState, companyZip,
    companyCountryCode, companyPhone, companyExt, companyCountry, companyAddress,
  } = useSelector(
    (state: RootState) => state.addCustomerReducer.formData,
  );
  const { customerId } = useParams();
  const {
    markups, countries,
  } = useSelector((state: RootState) => state.masterDataReducer);
  const {
    customerAlertData,
  } = useSelector((state: RootState) => state.addCustomerReducer);
  const selectedCountry = countries?.find((item) => item?.Value === companyCountry)?.Text;
  const selectedMarkupLabel = markups?.find((item) => item?.Value === String(markup))?.Text;

  const formatBoolean = (value: boolean) => (value ? 'Yes' : 'No');
  return (
    <div className={styles.companyInfoSection}>
      <h2 className={styles.heading}>Company Information</h2>
      <div className={styles.section}>
        <div className={styles.innerSection}>
          <label>Customer Name: </label>
          {' '}
          {customerName}
        </div>
        <div className={styles.innerSection}>
          <label>Customer Id: </label>
          {' '}
          {stripCustPrefix(customerId || '')}
        </div>
        <div className={styles.innerSection}>
          <label>Address: </label>
          {' '}
          {address}
        </div>
        <div className={styles.innerSection}>
          <label>Address (Optional): </label>
          {' '}
          {companyAddress}
        </div>
        <div className={styles.innerSection}>
          <label>Phone: </label>
          {' '}
          {companyPhone ? (
            <>
              {companyCountryCode}
              {' '}
              {companyPhone}
            </>
          ) : (
            <span />
          )}
        </div>
        <div className={styles.innerSection}>
          <label>Ext: </label>
          {' '}
          {companyExt}
        </div>
        <div className={styles.innerSection}>
          <label>Country: </label>
          {' '}
          {selectedCountry}
        </div>
        <div className={styles.innerSection}>
          <label>Zip: </label>
          {' '}
          {companyZip}
        </div>
        <div className={styles.innerSection}>
          <label>State: </label>
          {' '}
          {companyState}
        </div>
        <div className={styles.innerSection}>
          <label>City: </label>
          {' '}
          {companyOtherCity}
        </div>
        <div className={styles.innerSection}>
          <label>SMC: </label>
          {' '}
          {formatBoolean(smc)}
        </div>
        {smc === true && (
        <div className={styles.innerSection}>
          <label>Company Name (SMC): </label>
          {' '}
          {companyName}
        </div>
        )}
        <div className={styles.innerSection}>
          <label>Bid Alert: </label>
          {' '}
          {formatBoolean(bidAlert)}
        </div>
        {bidAlert === true
        && (
        <div className={styles.innerSection}>
          <label>Bid Alert Notes: </label>
          {' '}
          {bidAlertNote}
        </div>
        )}
        <div className={styles.innerSection}>
          <label>Customer Alert: </label>
          {' '}
          {formatBoolean(customerAlert)}
        </div>
        {customerAlert === true && (
        <div className={styles.innerSection}>
          <label>Customer Alert Notes: </label>
          {' '}
          {customerAlertData?.map((alert) => {
            const isSystemNote = alert.includes('-added by: ');
            const alertMsgs = isSystemNote ? alert.split('-added by: ') : alert.split('\n');
            if (isSystemNote) {
              return (
                <>
                  <p>{alertMsgs[1]}</p>
                  <p>{alertMsgs[0]}</p>
                  <p>{' '}</p>
                </>
              );
            } return (
              alertMsgs?.map((alrt) => <p>{alrt}</p>)
            );
          })}
        </div>
        )}

        <div className={styles.innerSection}>
          <label>Markup: </label>
          {' '}
          {selectedMarkupLabel}
        </div>
      </div>
    </div>
  );
}

export default CompanyInfo;
